import React, { Component } from 'react';
import logo from '../imgs/et2logo.png';
// import './Base.css';
import {Button,Input} from 'antd';
import {historyPush,request,requestAdminFormData} from '../utils/Util';
import './Home.css';

class Home extends Component {
    async startClick(){
        console.log(this.refs.name.state.value,this.refs.pwd.state.value);
        // {name: this.refs.name.state.value,
        //     form_build_id: 'form-lyTKR7dTyvQTGsfQ1wAYyNKqBhgfTPOu0mQfco5GSxU',
        //     op: '登录测试系统',
        //     form_id: 'test_test_taker_register_form',
        //     token: this.refs.pwd.state.value}
        const {match} = this.props;
        var formData = new FormData();
        formData.append('name',this.refs.name.state.value);
        formData.append('token',this.refs.pwd.state.value);
        formData.append('form_build_id','form-zI7DZJHvoTUF9vPxslYyycykCKuYqAECqvv53NBCtlw');
        formData.append('form_id','test_test_taker_register_form');
        formData.append('op','登录测试系统');
        sessionStorage.setItem('name',this.refs.name.state.value);
        sessionStorage.setItem('pwd',this.refs.pwd.state.value);
        const login = await requestAdminFormData(`http://t.loviact.org/test/${match.params.eid}/${match.params.eurl}`,'POST',formData);
        console.log(login);
        if(login.data.indexOf('Error') === -1){
            historyPush(`/question/${match.params.eid}/${match.params.eurl}/${match.params.etoken}`)
        }

        //
    }
    render() {
        const {match} = this.props;
        return (
            <div className='box home'>
                <header>
                    <img src={logo} alt=""/>
                </header>
                <section>
                    <div className='sub_header'>ACT Practice Test - English - Timed</div>
                    <div className='content'>
                        <div>
                            <div>登陆测试系统</div>
                            <p>这是首次使用。请输入你的姓名进行验证，并设置口令。说明如下：</p>
                            <span>只有首次使用时才验证姓名。</span>
                            <span>系统使用 cookie 来记录‘登录’信息。若 cookie（缓存）被清除、或需要在其他设备、或浏览器中访问时，需要输入口令进行验证。</span>
                            <span>本系统未针对窄屏设备做优化，请酌情使用。</span>
                            <div>
                                <span>姓名：</span>
                                <Input ref='name'  />
                            </div>
                            <div>
                                <span>口令：</span>
                                <Input ref='pwd' />
                            </div>
                        </div>
                        <div className='btn-group'>
                            <button onClick={this.startClick.bind(this)}>Start</button>
                        </div>
                        <hr/>
                    </div>
                </section>
                <footer>
                    <div>
                        ©2018-2019 PSI
                    </div>
                </footer>
            </div>
        );
    }
}

export default Home;
